import type { EChartsOption } from 'echarts';

/**
 * ECharts only hosts the tooltip: it never triggers it itself (see registerNearestSeriesTooltip),
 * and it draws the renderer's own cards without a frame of its own.
 */
export function buildTooltipOption(renderContent: () => string): Pick<EChartsOption, 'tooltip'> {
  return {
    tooltip: {
      trigger: 'item',
      triggerOn: 'none',
      transitionDuration: 0,
      formatter: renderContent,
      backgroundColor: 'transparent',
      borderWidth: 0,
      padding: 0,
      extraCssText: 'box-shadow:none;',
    },
  };
}
